<template>
  <v-app id="password-recovery">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="8" lg="6" xl="4">
            <v-card class="elevation-12 recovery-card">
              <v-overlay :value="overlay" opacity="0.8" z-index="5">
                <v-progress-circular
                  indeterminate
                  size="64"
                  color="primary"
                ></v-progress-circular>
                <div class="mt-4 white--text">Processando sua solicitação...</div>
              </v-overlay>
              
              <v-toolbar color="primary" dark flat>
                <v-btn icon @click="$router.push('/')" class="mr-2">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-title class="text-center flex-grow-1">
                  <v-icon large left>mdi-lock-reset</v-icon>
                  Recuperar Senha
                </v-toolbar-title>
              </v-toolbar>

              <v-card-text class="px-6 py-8">
                <div v-if="(falal !== null && !falal.includes('status'))" class="error-message">
                  <v-icon color="error" left>mdi-alert-circle</v-icon>
                  {{ falal }}
                </div>
                
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-text-field
                    v-model="user.username"
                    label="E-mail cadastrado"
                    prepend-inner-icon="mdi-email-outline"
                    outlined
                    rounded
                    :rules="ruleEmailRequired"
                    autocomplete="email"
                    type="email"
                    class="mb-4"
                  ></v-text-field>
                </v-form>

                <div v-if="progresso" class="text-center py-4">
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                  <div class="mt-3 caption grey--text">Verificando seu e-mail...</div>
                </div>
              </v-card-text>
              
              <v-card-actions class="px-6 pb-6">
                <v-btn
                  block
                  x-large
                  color="primary"
                  :disabled="!formValid"
                  @click="RecuperarSenha()"
                  depressed
                  rounded
                  class="recovery-button"
                >
                  <v-icon left>mdi-email-send-outline</v-icon>
                  Enviar Instruções
                </v-btn>
              </v-card-actions>
              
              <v-divider></v-divider>
              
              <div class="text-center pa-4">
                <v-btn text small color="primary" @click="$router.push('/')">
                  <v-icon left small>mdi-login</v-icon>
                  Lembrou sua senha? Faça login
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      
      <v-snackbar
        v-model="showResult"
        :timeout="4000"
        :color="cor"
        top
        rounded="pill"
      >
        <v-icon left>{{ cor === 'orange' ? 'mdi-alert' : 'mdi-alert-circle' }}</v-icon>
        {{ result }}
        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            v-bind="attrs"
            @click="showResult = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      
      <v-snackbar
        v-model="showResultSucesso"
        :timeout="5000"
        color="success"
        top
        rounded="pill"
      >
        <v-icon left>mdi-check-circle</v-icon>
        {{ result }}
        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            v-bind="attrs"
            @click="showResultSucesso = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import axios from '../../plugins/axios'
import { v4 as uuidv4 } from 'uuid'
const ls = require('local-storage')
export default {
  props: {
    source: String
  },
  data: () => ({
    formValid: true,
    conectionStatus: '',
    progresso: false,
    browser: '',
    showResult: '',
    result: '',
    overlay: false,
    cor: '',
    resultUsuario: '',
    showResultSucesso: false,
    counter_: 0,
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'Máximo número de carácteres atigidos',
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /([^A-Za-z0-9])$/
        return !pattern.test(v) || 'Inválido.'
      }
    ],
    drawer: null,
    user: {
      username: '',
      password: ''
    },
    userDefault: {
      username: '',
      password: ''
    },
    long: '',
    lat: ''
  }),

  computed: {
    loggedUser () {
      const user = this.$store.getters.loggedUser
      return user // this.$session.get("role")// this.$session.getAll()// this.$session.flash.get("role")
    },
    falal () {
      return ls.get('fatal')
    }

  },

  created () {
    this.CheckConection()
    console.log(this.conectionStatus)
    ls.set('mensagensDefault', [])
    this.browser = this.$browserDetect.meta.name
  },

  methods: {

    CheckConection () {
      if (!navigator.onLine) { this.conectionStatus = 'Verifique a sua conexão de internet' }
    },

    async RecuperarSenha () {
      this.overlay = true

      if (!this.user.username.includes("'") && !this.user.username.includes('"')) {
        const userCredencial =
        {
          username: this.user.username
        }

        this.ValidarEmail(userCredencial).then(async () => {
          if (this.resultUsuario.nomeUsuario !== undefined && this.resultUsuario.enable === 1) {
            let cred = {
              username: userCredencial.username,
              nome: this.resultUsuario.nomeUsuario,
              addressURL: window.location.host
            }
            try {
              const msg = await axios
                .post('/Recuperar', cred)
                .then(res => res.data)

                console.log(msg, ' a mensagem GGG');
                
              if (msg.sucesso) {
                this.result = 'Foi enviado um e-mail com as instruções para proceder à definição de uma nova senha.'
                this.showResultSucesso = true
                this.user = this.userDefault
              }
              this.overlay = false
            } catch (error) {
              this.overlay = false
              this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
            }
          } else {
            if (this.resultUsuario.enable === 0) { this.result = 'Esta Conta esta desactivada'; this.cor = 'orange' } else { this.result = 'Este e-mail não existe na nossa base de dados'; this.cor = 'red' }
            this.showResult = true
            this.overlay = false
          }
        })
      } else {
        this.$store.dispatch('usuario', { 'msg': 'Inválido !', 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async   ValidarEmail (userCredencial) {
      try {
        this.resultUsuario = await axios
          .post('/ValidarEmail', userCredencial)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.progresso = false
      }
    }

  }

}
</script>
<style scoped lang="scss">
.recovery-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  
  .v-toolbar {
    background: linear-gradient(135deg, var(--v-primary-base) 0%, #1565C0 100%);
  }
  
  .error-message {
    background-color: #FFF3F3;
    color: #FF5252;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    border-left: 4px solid #FF5252;
  }
  
  .recovery-button {
    font-weight: 600;
    letter-spacing: 0.5px;
    height: 48px !important;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .recovery-card {
    margin: 16px;
  }
}

@media (max-width: 600px) {
  .v-toolbar__title {
    font-size: 1.25rem !important;
    
    .v-icon {
      font-size: 1.5rem !important;
    }
  }
  
  .recovery-card {
    border-radius: 12px !important;
  }
  
  .v-card__text {
    padding: 24px 16px !important;
  }
}
</style>
